import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const navLinks = isHome
    ? [
        { label: 'Willkommen', href: '#hero' },
        { label: 'Angebote', href: '#angebote' },
        { label: 'Über mich', href: '#about' },
        { label: 'Kontakt', href: '#contact' },
      ]
    : [
        { label: 'Startseite', href: '/' },
        { label: 'Angebote', href: '/#angebote' },
        { label: 'Über mich', href: '/#about' },
        { label: 'Kontakt', href: '/#contact' },
      ];

  const handleNavClick = (e, href) => {
    setMobileOpen(false);
    if (href.startsWith('#')) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <Link to="/" className="header-logo" data-testid="header-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/vce2hnta_MitGef%C3%BChl%20LOGO%20transparent%20Hintergrund.png"
            alt="MitGefühl Logo"
            className="header-logo-img"
          />
          <span className="header-logo-text">MitGefühl</span>
        </Link>

        <nav className="header-nav desktop-nav" data-testid="desktop-nav">
          {navLinks.map((link) =>
            link.href.startsWith('/') && !link.href.startsWith('/#') ? (
              <Link key={link.label} to={link.href} className="nav-link" data-testid={`nav-${link.label.toLowerCase()}`}>
                {link.label}
              </Link>
            ) : link.href.startsWith('/#') ? (
              <Link key={link.label} to={link.href} className="nav-link" data-testid={`nav-${link.label.toLowerCase()}`}>
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className="nav-link"
                onClick={(e) => handleNavClick(e, link.href)}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            )
          )}
        </nav>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü"
        >
          {mobileOpen ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      {mobileOpen && (
        <nav className="mobile-nav" data-testid="mobile-nav">
          {navLinks.map((link) =>
            link.href.startsWith('/') && !link.href.startsWith('/#') ? (
              <Link
                key={link.label}
                to={link.href}
                className="mobile-nav-link"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ) : link.href.startsWith('/#') ? (
              <Link
                key={link.label}
                to={link.href}
                className="mobile-nav-link"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className="mobile-nav-link"
                onClick={(e) => handleNavClick(e, link.href)}
              >
                {link.label}
              </a>
            )
          )}
        </nav>
      )}
    </header>
  );
}

export function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand-section">
            <Link to="/" className="footer-brand-link">
              <img
                src="https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/vce2hnta_MitGef%C3%BChl%20LOGO%20transparent%20Hintergrund.png"
                alt="MitGefühl Logo"
                className="footer-logo-image"
              />
              <span className="footer-brand-name">MitGefühl</span>
            </Link>
            <p className="footer-tagline">Coaching und Beratung</p>
          </div>

          <div className="footer-nav-section">
            <Link to="/#angebote" className="footer-nav-link" data-testid="footer-angebote">Angebote</Link>
            <Link to="/#about" className="footer-nav-link" data-testid="footer-about">Über mich</Link>
            <Link to="/#contact" className="footer-nav-link" data-testid="footer-kontakt">Kontakt</Link>
          </div>

          <div className="footer-legal-section">
            <Link to="/impressum" className="footer-nav-link" data-testid="footer-impressum">Impressum</Link>
            <Link to="/datenschutz" className="footer-nav-link" data-testid="footer-datenschutz">Datenschutz</Link>
            <Link to="/agb" className="footer-nav-link" data-testid="footer-agb">AGB</Link>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MitGefühl &ndash; Vanessa Würzler. Alle Rechte vorbehalten.</p>
          <p className="footer-credit">Made by Boris Marketing</p>
        </div>
      </div>
    </footer>
  );
}
